// src/services/telemetry.js
const FN_BASE = '/.netlify/functions';

export async function logConsent({ type, action, policyVersion, userId, pagePath }) {
  try {
    await fetch(`${FN_BASE}/logConsent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, action, policyVersion, userId, pagePath }),
    });
  } catch (e) {
    console.error('logConsent failed', e);
  }
}

export async function logOrderSubmission(payload) {
  try {
    await fetch(`${FN_BASE}/logOrder`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    console.error('logOrderSubmission failed', e);
  }
}
